type paramsType = {
  slug: string
}

type paramsTelType = {
  prefix: string
  phoneNumber: string
}

type paramsWhatsappType = paramsTelType & {
  text: string
}

export default function () {
  const onlineBookingReview = (): string => {
    return 'https://escapadaruralcom.typeform.com/to/RI87I8G2?utm_campaign=succes_RO'
  }

  const uploadNif = (params: paramsType): string => {
    return `https://escapadaruralcom.typeform.com/to/UU7xgikM#id=${params.slug}`
  }

  const uploadCif = (params: paramsType): string => {
    return `https://escapadaruralcom.typeform.com/to/MgddqVTE#id=${params.slug}`
  }

  const youtubeVideo = (params: paramsType): string => {
    return `https://www.youtube.com/embed/${params.slug}`
  }

  const tel = (params: paramsTelType): string => {
    return `tel:${params.prefix}${params.phoneNumber.replace(/\s+/g, '')}`
  }

  const whatsapp = (params: paramsWhatsappType): string => {
    const rawURL = new URL(
      `https://wa.me/${params.prefix}${params.phoneNumber.replace(/\s+/g, '')}`,
    )

    rawURL.searchParams.set('text', params.text)

    return rawURL.href
  }

  const normalizeURL = (url: string): string => {
    if (url.search(/^http[s]?:\/\//) == -1) {
      url = 'https://' + url
    }
    return url
  }

  return {
    onlineBookingReview,
    uploadNif,
    uploadCif,
    youtubeVideo,
    tel,
    whatsapp,
    normalizeURL,
  }
}
